import { useSearchPersonStore } from '@aibees/elephant/feature/search-table-people/store';
import { useMemo } from 'react';

export function usePeopleDrawerHeaderNavigationButtonsState(): [
  boolean,
  boolean
] {
  const { peopleSearchItems, id } = useSearchPersonStore();
  const tableIds = peopleSearchItems.map((item) => item.id);

  return useMemo(() => {
    const prevDisabled = !id || tableIds.indexOf(id) === 0;
    const nextDisabled = !id || tableIds.indexOf(id) === tableIds.length - 1;
    return [prevDisabled, nextDisabled];
  }, [id, tableIds]);
}
